package music.jammers.client.shared.profile.domain

import music.jammers.shared.user.domain.model.User
import music.jammers.shared.user.domain.model.UserProfileUpdateData
import music.limasoul.client.shared.user.domain.repository.UserRepository

class SaveNewUserProfileDataCase(
    private val userRepository: UserRepository
) {
    suspend operator fun invoke(updateUserModel: UserProfileUpdateData): User {
        return userRepository.update(updateUserModel)
    }
}